// The details that appear in the Privacy Policy and the Terms & Conditions. Fill in every value that is in [SQUARE BRACKETS]
// before you publish. While any bracket remains, the documents show a yellow "draft" notice so an unfinished version can't go
// out unnoticed.
//
// When you change what a document says in a way that matters to people, raise its version and the "updated" date. The version
// the person accepted at sign-up is saved with their account.

export const LEGAL = {
  product: "Balance & Beyond",
  company: "[YOUR COMPANY OR TRADING NAME]",
  address: "[YOUR BUSINESS ADDRESS]",
  contactEmail: "[YOUR PRIVACY AND SUPPORT EMAIL]",
  jurisdiction: "[YOUR STATE OR COUNTRY WHOSE LAWS APPLY, e.g. New South Wales, Australia]",
  dataRegion: "[WHERE YOUR SUPABASE PROJECT IS HOSTED, e.g. Sydney, Australia]",
  minAge: 16,
  updated: "27 October 2026",
  privacyVersion: "1.0",
  termsVersion: "1.0",
};

export const legalIsDraft = () => Object.values(LEGAL).some((v) => typeof v === "string" && v.includes("["));

// What gets saved on the account when someone ticks the box at sign-up.
export const consentRecord = () => ({
  terms_version: LEGAL.termsVersion,
  privacy_version: LEGAL.privacyVersion,
  terms_accepted_at: new Date().toISOString(),
});
